import { insertWithUploadPlaceholder } from "@/components/tiptap/UploadPlaceholder";
import { uploadFileAttachment } from "@/components/tiptap/utils/uploadFileAttachment";

import type { UploadScope } from "@/components/tiptap/utils/uploadScope";
import type { EditorView } from "@tiptap/pm/view";

export function insertFileAttachment(
  view: EditorView,
  position: number,
  file: File,
  scope: UploadScope,
): boolean {
  const { fileAttachment } = view.state.schema.nodes;
  if (!fileAttachment) return false;

  const controller = new AbortController();
  insertWithUploadPlaceholder(
    view,
    fileAttachment,
    position,
    file,
    (onProgress) => uploadFileAttachment(file, scope, { onProgress, signal: controller.signal }),
    (attrs) => fileAttachment.create(attrs),
    { controller },
  );
  return true;
}
